// @flow
import styled from 'styled-components';

import { above } from '../../assets/css/media';

export const OneColumnLayout = styled.div`
	width: 100%;
	max-width: ${({ width }) => width ? width : '870px'};
	margin: 0 auto;
	
	${above.tablet`
		padding: 0 10px;
	`}
`;

export default OneColumnLayout;


// WEBPACK FOOTER //
// ./src/components/OneColumnLayout/index.js